import {
    Paper,
    Typography,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Tooltip,
    Grid2 as Grid,
    IconButton
} from "@mui/material";
import * as React from "react";
import { connect } from "react-redux";
import SharedUtility from "../../Utilities/SharedUtility";
import { Theme, createStyles } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import idssStyle from "../../Configuration/SharedStyling";
import {
    ISelectedSubmissions, ISubmissionPayload
} from "../../DataClasses/SubmissionData";
import SubmissionsService from "../Services/SubmissionsService";
import { AjaxError } from "rxjs/ajax";
import * as AuthorizationPolicies from "../../Configuration/AuthorizationPolicies";
import { Edit } from '@mui/icons-material';
import { Link, LinkProps, RouteComponentProps } from 'react-router-dom';
import { Redirect } from "react-router-dom";
import { User } from "oidc-client";
import * as actionTypes from '../../State/SubmissionListing/Action';
import { firstValueFrom } from "rxjs";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    step: {
        padding: '10px 22px',
        margin: theme.spacing(1)
    },
    selectedOrganizationId: {
        width: '50%',
        marginTop: theme.spacing(1)
    },
    bulkActionContainer: {
        flexGrow: 1,
        justifyContent: 'left',
        justifyItems: 'left'
    }
});

const TableColumns = [
    { "Id": 1, "Name": "Actions" },
    { "Id": 2, "Name": "Org ID" },
    { "Id": 3, "Name": "Sub ID" },
    { "Id": 4, "Name": "Org Name" },
    { "Id": 5, "Name": "Component" },
    { "Id": 6, "Name": "Product Line" },
    { "Id": 7, "Name": "Validation Status" },
    { "Id": 8, "Name": "Reporting Product" },
    { "Id": 9, "Name": "Special Project" },
    { "Id": 10, "Name": "Special Area" },
    { "Id": 11, "Name": "CMS Contract" },
    { "Id": 12, "Name": "Reporting Unit Id" },
    { "Id": 13, "Name": "Received" },
    { "Id": 14, "Name": "Stage" },
    { "Id": 15, "Name": "Survey Vendor" },
    { "Id": 16, "Name": "Public Reporting" }
];

interface ISubmissionsListingState {
    isLoading: boolean,
    isProcessing: boolean,
    isValidDownload: boolean,
    isAdmin: boolean,
    selectedSubmissions: ISelectedSubmissions[],
    rowsSelected: number[],
    tableData: any[],
    bulkAnchorEl: null | Element,
    tableFilters: undefined | IFilterInputParameters,
    redirect: boolean
}

interface IFilterInputParameters {
    productLine: string | undefined;
    stage: string | undefined;
    orgId: string | undefined;
}

interface IComponentStoreProps {
    user: User | null;
    viewColumnsSelected: string[];
    showAllSubmissions: boolean;
    showTestOrgsSubs: boolean;
    rowsPerPageSelected: number;
    storedFilterList: any;
}

interface IComponentDispatchProps {
    addColumn: (column: string) => void;
    removeColumn: (column: string) => void;
    setInitialColumns: (columnsList: string[]) => void;
    setAllSubmissions: (value: boolean) => void;
    setTestOrgsSubs: (value: boolean) => void;
    setRowsPerPage: (value: number) => void;
    setTableFilter: (filterList: any) => void;
}

type IStylesProps = WithStyles<typeof styles>;
type IComponentProps = IStylesProps & IComponentStoreProps & IComponentDispatchProps

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
    <Link innerRef={ref as any} {...props} />
));

// VIEW
class AllSubmissionsView extends React.Component<
    IComponentProps & RouteComponentProps<IFilterInputParameters>,
    ISubmissionsListingState
> {
    constructor(props) {
        super(props);

        let filters = props.match.params as IFilterInputParameters | undefined;
        if (filters) {
            this.setTableFilterBasedOnUrl(filters);
        }
        this.state =
        {
            isLoading: true,
            isProcessing: false,
            isValidDownload: true,
            isAdmin: AuthorizationPolicies.IsGlobalAdmin(this.props.user),
            selectedSubmissions: [],
            rowsSelected: [],
            tableData: [],
            bulkAnchorEl: null,
            tableFilters: filters,
            redirect: false
        };
    }

    public componentDidUpdate(prevProps) {
        let filters = this.props.match.params as IFilterInputParameters | undefined;
        if (filters) {
            this.setTableFilterBasedOnUrl(filters);
        }
        if (prevProps.match.params !== filters) {
            this.setState({ tableFilters: filters });
        }
    }

    private setTableFilterBasedOnUrl(filters: IFilterInputParameters) {
        if(filters.productLine === 'all' && filters.stage === 'all' && filters.orgId === 'all') {
            this.props.setTableFilter([]);
        }
        else if(filters.orgId && filters.orgId.length > 0 && filters.orgId !== 'all') {
            this.props.setTableFilter([{"id":"orgId","value":[filters.orgId]}]);
        }
        else if(filters.productLine && filters.productLine.length > 0 && filters.productLine !== 'all') {
            this.props.setTableFilter([{"id":"productLine","value":[filters.productLine]}]);
        }
        else if(filters.stage && filters.stage.length > 0 && filters.stage !== 'all') {
            this.props.setTableFilter([{"id":"stage","value":[filters.stage]}]);
        }
        filters.orgId = undefined;
        filters.productLine = undefined;
        filters.stage = undefined;
    }

    public componentDidMount() {
        this.refreshModel(this.props.showAllSubmissions, this.props.showTestOrgsSubs);

        //set default visible columns in state initially
        if (!this.props.viewColumnsSelected || this.props.viewColumnsSelected.length === 0) {
            var columnsList = TableColumns
                .filter(c => c.Name !== "Validation Status" && c.Name !== "Survey Vendor")
                .map(c => c.Name);
            this.props.setInitialColumns(columnsList);
        }
    }

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }

        const { classes } = this.props;

        // Convert array data to objects for Shared DataTable
        const tableData = this.state.tableData.map((row, index) => ({
            id: `${row[1]}-${row[2]}-${index}`, // Create unique ID using orgId, subId, and index
            actions: row[0],
            orgId: row[1],
            subId: row[2],
            orgName: row[3],
            component: row[4],
            productLine: row[5],
            validationStatus: row[6],
            reportingProduct: row[7],
            specialProject: row[8],
            specialArea: row[9],
            cmsContract: row[10],
            reportingUnitId: row[11],
            received: row[12],
            stage: row[13],
            surveyVendor: row[14],
            publicReporting: row[15]
        }));

        // Build visibility map so we can include all columns in the definition but hide per user prefs
        const columnVisibility = {
            actions: this.showColumn('Actions'),
            orgId: this.showColumn('Org ID'),
            subId: this.showColumn('Sub ID'),
            orgName: this.showColumn('Org Name'),
            component: this.showColumn('Component'),
            productLine: this.showColumn('Product Line'),
            validationStatus: this.showColumn('Validation Status'),
            reportingProduct: this.showColumn('Reporting Product'),
            specialProject: this.showColumn('Special Project'),
            specialArea: this.showColumn('Special Area'),
            cmsContract: this.showColumn('CMS Contract'),
            reportingUnitId: this.showColumn('Reporting Unit Id'),
            received: this.showColumn('Received'),
            stage: this.showColumn('Stage'),
            surveyVendor: this.showColumn('Survey Vendor'),
            publicReporting: this.showColumn('Public Reporting'),
        } as const;

        return (
            <Grid container={true} spacing={2} className={classes.mainPanel + " " + classes.root}>
                <Grid size={12}>
                    <Typography className={classes.submissionTitle}>
                        {'Submissions' + (this.state.tableFilters && this.state.tableFilters.orgId && this.state.tableFilters.orgId !== 'all' ? ' for Org ID ' + this.state.tableFilters.orgId : '')}
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <div>
                        {this.state.isAdmin ?
                            <FormGroup row>
                                <FormControlLabel className={classes.noBottomMargin}
                                    style={{ marginRight: '50px' }}
                                    control={
                                        <Checkbox
                                            checked={this.props.showAllSubmissions}
                                            onChange={async () => this.toggleGetAllUsers()}
                                            color="primary"
                                        />
                                    }
                                    label="Show All Submissions"
                                />
                                <FormControlLabel className={classes.noBottomMargin}
                                    control={
                                        <Checkbox
                                            checked={this.props.showTestOrgsSubs}
                                            onChange={async () => this.toggleGetTestOrgsSubs()}
                                            color="primary"
                                        />
                                    }
                                    label="Show Test Orgs Submissions Only"
                                />
                            </FormGroup> : ''
                        }
                        {!this.state.isValidDownload ?
                            <Paper>
                                <Typography variant="subtitle2" style={{ color: '#FF0000', paddingLeft: '15px' }}>
                                    No files available for download.
                                </Typography>
                            </Paper> : ''}
                    </div>
                </Grid>

                <Grid size={12}>
                    <SharedMaterialReactTable
                        data={tableData}
                        columns={this.getTableColumns()}
                        title={"Available Submissions"}
                        isLoading={this.state.isLoading}
                        enablePagination={true}
                        enableSorting={true}
                        enableFilterModal={true}
                        enableFiltering={true}
                        enableColumnActions={true}
                        enableRowActions={false}
                        enableDownloadCsv={true}
                        enableShowHideColumns={true}
                        layoutMode="fixed"
                        initialState={{
                            pagination: { pageIndex: 0, pageSize: this.props.rowsPerPageSelected },
                            columnVisibility: columnVisibility,
                            columnFilters: this.props.storedFilterList ?? undefined
                        }}
                        muiPaginationProps={{
                            rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                        }}
                        emptyMessage="No submissions found."
                        setTableFilters={this.props.setTableFilter}
                    />
                </Grid>
            </Grid>
        )
    }

    private showColumn(name: string): boolean {
        if (!this.props.viewColumnsSelected || this.props.viewColumnsSelected.length === 0)
            return true;
        return this.props.viewColumnsSelected.some(c => c === name);
    }

    private async toggleGetTestOrgsSubs() {
        this.setState({ isLoading: true });
        if (this.props.showAllSubmissions && !this.props.showTestOrgsSubs)
            this.props.setAllSubmissions(false);
        await this.refreshModel(false, !this.props.showTestOrgsSubs);
        this.props.setTestOrgsSubs(!this.props.showTestOrgsSubs);
        this.setState({ isLoading: false });
    }

    private async toggleGetAllUsers() {
        this.setState({ isLoading: true });
        if (this.props.showTestOrgsSubs && !this.props.showAllSubmissions)
            this.props.setTestOrgsSubs(false);
        await this.refreshModel(!this.props.showAllSubmissions, false);
        this.props.setAllSubmissions(!this.props.showAllSubmissions);
        this.setState({ isLoading: false });
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private async refreshModel(showAllSubmissions: boolean, showTestOrgsSubs: boolean) {
        this.setState({ isLoading: true });
        let retval: ISubmissionPayload[];

        if (showTestOrgsSubs) {
            retval = await firstValueFrom(SubmissionsService.GetTestSubmissionsForUser$(this.props.user));
        }
        else {
            retval = await firstValueFrom(
                SubmissionsService.GetSubmissionsForUser$(
                    this.props.user,
                    showAllSubmissions
                )
            );
        }

        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            let submissionData: any[] = retval
                .map(item => {
                    return [
                        item.canEdit ? item.subId + "/" + item.component + "/" + item.productLine : "",
                        item.orgId,
                        item.subId,
                        item.orgName,
                        item.component.replace("DST", "HEDIS"),
                        item.productLine,
                        item.validationStatus,
                        item.reportingProduct,
                        item.specialProject,
                        item.specialArea,
                        item.cmsContractNumber,
                        item.reportingUnitId,
                        item.received,
                        SharedUtility.GetStageCleanName(item.submissionStatus),
                        item.componentVendorName === null ? "None" : item.componentVendorName,
                        item.isPublicReported !== null ? (item.isPublicReported === true ? "Yes" : "No") : "Not Set"
                    ];
                });


            this.setState({
                tableData: submissionData
            });
            this.setState({ isLoading: false });
        }
    }

    private getTableColumns = (): ISharedTableColumn<any>[] => {
        const cols: ISharedTableColumn<any>[] = [
            {
                accessorKey: 'actions' as any,
                header: 'Actions',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                size: 70,
                Cell: ({ row }) => {
                    const submissionHomeText = "/submissionHome/" + row.original.actions;
                    return row.original.actions === "" ? null : (
                        <Tooltip title="Submission Home" aria-label="submissionHome">
                            <IconButton size='small' aria-label="submissionHome" to={submissionHomeText} component={AdapterLink}>
                                <Edit fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    );
                }
            },
            {
                accessorKey: 'orgId' as any,
                header: 'Org ID',
                enableSorting: true,
                enableFiltering: true,
                size: 80
            },
            {
                accessorKey: 'subId' as any,
                header: 'Sub ID',
                enableSorting: true,
                enableFiltering: false,
                size: 80
            },
            {
                accessorKey: 'orgName' as any,
                header: 'Org Name',
                enableSorting: true,
                enableFiltering: false,
                size: 250,
                grow: false
            },
            {
                accessorKey: 'component' as any,
                header: 'Component',
                enableSorting: true,
                enableFiltering: true,
                size: 110
            },
            {
                accessorKey: 'productLine' as any,
                header: 'Product Line',
                enableSorting: true,
                enableFiltering: true,
                size: 120
            },
            {
                accessorKey: 'validationStatus' as any,
                header: 'Validation Status',
                enableSorting: true,
                enableFiltering: true,
                size: 150
            },
            {
                accessorKey: 'reportingProduct' as any,
                header: 'Reporting Product',
                enableSorting: true,
                enableFiltering: false,
                size: 150
            },
            {
                accessorKey: 'specialProject' as any,
                header: 'Special Project',
                enableSorting: true,
                enableFiltering: false,
                size: 150
            },
            {
                accessorKey: 'specialArea' as any,
                header: 'Special Area',
                enableSorting: true,
                enableFiltering: false,
                size: 120
            },
            {
                accessorKey: 'cmsContract' as any,
                header: 'CMS Contract',
                enableSorting: true,
                enableFiltering: false,
                size: 120
            },
            {
                accessorKey: 'reportingUnitId' as any,
                header: 'Reporting Unit Id',
                enableSorting: true,
                enableFiltering: false,
                size: 150
            },
            {
                accessorKey: 'received' as any,
                header: 'Received',
                enableSorting: true,
                enableFiltering: true,
                size: 120
            },
            {
                accessorKey: 'stage' as any,
                header: 'Stage',
                enableSorting: true,
                enableFiltering: true,
                size: 120
            },
            {
                accessorKey: 'surveyVendor' as any,
                header: 'Survey Vendor',
                enableSorting: true,
                enableFiltering: true,
                size: 150
            },
            {
                accessorKey: 'publicReporting' as any,
                header: 'Public Reporting',
                enableSorting: true,
                enableFiltering: true,
                size: 150,
                Cell: ({ row }) => {
                    if (row.original.publicReporting === "Not Set") {
                        return <span style={{ color: "red" }}>{row.original.publicReporting}</span>;
                    }
                    return row.original.publicReporting;
                }
            }
        ];

        // Return all columns; visibility is controlled via initialState.columnVisibility so
        // hidden columns can still be filterable in the popover.
        return cols;
    };
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer.user,
        viewColumnsSelected: state.SubmissionListingReducer.selectedSubmissionColumns,
        rowsPerPageSelected: state.SubmissionListingReducer.rowsPerPageSelected,
        showAllSubmissions: state.SubmissionListingReducer.showAllSubmissions,
        showTestOrgsSubs: state.SubmissionListingReducer.showTestOrgsSubs,
        storedFilterList: state.SubmissionListingReducer.storedFilterList
    };
}

const mapDispatchToProps = (dispatch): IComponentDispatchProps => {
    return {
        addColumn: (column: string) => dispatch({ type: actionTypes.ADD_COLUMN, payload: column }),
        removeColumn: (column: string) => dispatch({ type: actionTypes.REMOVE_COLUMN, payload: column }),
        setInitialColumns: (columnsList: string[]) => dispatch({ type: actionTypes.SET_INITIAL_COLUMNS, payload: columnsList }),
        setAllSubmissions: (value: boolean) => dispatch({ type: actionTypes.SET_ALL_SUBMISSIONS, payload: value }),
        setTestOrgsSubs: (value: boolean) => dispatch({ type: actionTypes.SET_TEST_ORGS_SUBS, payload: value }),
        setRowsPerPage: (value: number) => dispatch({ type: actionTypes.SET_SUBMISSION_PER_PAGE, payload: value }),
        setTableFilter: (filterList: any) => dispatch({ type: actionTypes.SET_TABLE_FILTER, payload: filterList })
    };
}

// REDUX CONTAINER
const AvailableSubmissionsPageWithState = connect<IComponentStoreProps, IComponentDispatchProps>(
    mapStateToProps, mapDispatchToProps
)(AllSubmissionsView);

// STYLES CONTAINER
const AvailableSubmissionsPage = withStyles(styles)(
    AvailableSubmissionsPageWithState
);

export default AvailableSubmissionsPage;
